import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faPenLine } from '@fortawesome/pro-regular-svg-icons/faPenLine';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Space } from 'antd';
import { StatusTag } from 'pos-client/components/generic/status-tag/StatusTag.tsx';
import { TabsOutlet } from 'pos-client/components/shared/Layout/Tabs/TabsOutlet.tsx';
import { useLocationModal } from 'pos-client/hooks/useLocationModal.tsx';
import { useLocation } from 'pos-client/hooks/useLocations.tsx';
import { usePermissions } from 'pos-client/hooks/usePermissions.tsx';
import { locationTabs } from 'pos-client/tabs/locationTabs.ts';
import { createTabs } from 'pos-client/utils/createTabs.tsx';

import { CreateEditLocationModal } from './Modals/CreateEditLocationModal.tsx';

export const LocationDetailsPage = () => {
  const { locationId: id } = useParams<'locationId'>();
  const { isLoadingLocation, location } = useLocation(id, {}, true, {
    loadLinkedCategories: true,
  });
  const { t } = useTranslation();
  const { hasPermissions } = usePermissions();
  const canAddAndEditAssets = hasPermissions('add.edit.location.assets');
  const {
    isLocationModalOpen,
    showLocationModal,
    hideLocationModal,
    deleteLocationHandler,
  } = useLocationModal({ location });

  let locationTabList = createTabs(locationTabs, { location });

  if (!location?.serviceTypes.includes('Mobile')) {
    locationTabList = locationTabList.filter((tab) => {
      return tab.key !== locationTabs.routes.key;
    });
  }
  if (!location?.serviceTypes.includes('Static')) {
    locationTabList = locationTabList.filter((tab) => {
      return tab.key !== locationTabs.serviceMatrix.key;
    });
  }

  const actionComponent = () => {
    return (
      <Space>
        <Link to={`/locations`}>
          <Button type="primary" icon={<FontAwesomeIcon icon={faArrowLeft} />}>
            {t('locations.backToLocations')}
          </Button>
        </Link>
        {canAddAndEditAssets && (
          <>
            <Button
              type="primary"
              onClick={showLocationModal}
              icon={<FontAwesomeIcon icon={faPenLine} />}
            >
              {t('locations.editLocation')}
            </Button>
            <Button type="primary" onClick={deleteLocationHandler} danger>
              {t('locations.deleteServiceLocation')}
            </Button>
          </>
        )}
      </Space>
    );
  };
  return (
    <>
      <TabsOutlet
        tabs={locationTabList}
        title={location?.name ?? ''}
        actionComponent={actionComponent()}
        statusTag={
          <StatusTag status={location?.isActive ? 'active' : 'inactive'} />
        }
        loading={isLoadingLocation}
      />
      <CreateEditLocationModal
        isOpen={isLocationModalOpen}
        hideModal={hideLocationModal}
        location={location}
      />
    </>
  );
};
